<ng-container>
    <ng-template #subItem let-item>
        <li [class.has-sub]="item.children && item.children.length > 0"
            [class.active]="isActive(item.link)"
            [class.open]="openMenus[item.link]"
            style="cursor: grab;">
          <a
            (click)="loadNavOnClick(item.link)">
            {{ item.label }}
            <span *ngIf="item.children && item.children.length > 0 && !isDesktop" class="arrow">
                {{ openMenus[item.link] ? '-' : '+' }}
            </span>
          </a>
          <ul *ngIf="item.children && item.children.length > 0 && (isDesktop || openMenus[item.link])" class="nav_menu nav_menu_sub">
            <ng-container *ngFor="let subChild of item.children">
              <ng-container *ngTemplateOutlet="subItem; context: { $implicit: subChild }"></ng-container>
            </ng-container>
          </ul>
        </li>
    </ng-template>
      

    <ng-template #rootItem let-item>
        <li class="level0 has-sub" [class.active]="isActive(item.link)" [class.open]="openMenus[item.path]" style="cursor: grab;">
            <a (click)="loadNavOnClick(item.link)">
                {{item.data.label | uppercase}}
                <span *ngIf="item.childNavs && item.childNavs.length > 0 && !isDesktop" class="arrow">
                    {{ openMenus[item.path] ? '-' : '+' }}
                </span>
            </a>
            <ul *ngIf="item.childNavs && item.childNavs.length > 0 && (isDesktop || openMenus[item.path])" class="nav_menu nav_menu_full">
                <ng-container *ngFor="let child of item.childNavs">
                    <ng-container *ngTemplateOutlet="subItem; context: {$implicit: child}"></ng-container>
                </ng-container>
            </ul>
        </li>
    </ng-template>

    <div id="menu">
        <button id="hamburger-btn" (click)="toggleMobileMenu()" aria-label="Open menu" class="hamburger-btn" [class.open]="mobileMenuOpen">
            <span class="menu-text">MENU</span>
            <span class="menu-icon">&#9776;</span>
        </button>
         <nav class="nav" id="multimenu" [class.open]="mobileMenuOpen || isDesktop">
            <ul class="nav_menu nav_menu_full nav_menu_root">

                <ng-container>

                    <ng-container *ngFor="let item of data">
                        <ng-container *ngTemplateOutlet="rootItem; context: {$implicit: item}"></ng-container>
                    </ng-container>

                    <li *ngIf="this.isRegMode" class="level0 has-sub">
                        <a style="cursor: pointer;" [class.active]="isActive">{{this.regRole | uppercase}}</a>
                    </li>

                    <!-- 
                    The following commented out element is for the logout nav
                    Instead of always showing it, we will now need a logout nav for each app that points to the logout page (page ID = 5)
                    <li class="level0">
                        <a (click)="logout()">{{this.isRegMode ? "Back to Login" : "LOGOUT"}}</a>
                    </li>
                     -->
                    
                </ng-container>
            </ul>
        </nav>
    </div>
</ng-container>
